import React from 'react';
import type { DropdownProps } from 'antd';

import StyledDropdown from './styled.tsx';

export const BaseDropdown: React.FC<DropdownProps> = (props) => <StyledDropdown {...props} />;
